import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { DASHBOARD } from 'queries/query-keys';

const useCustomBlockRefreshHook = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const hook = {
      refresh: async (id) => {
        await queryClient.invalidateQueries({
          queryKey: id ? [...DASHBOARD.DASHBOARD, id] : DASHBOARD.DASHBOARD,
        });
        return { refreshed: true, dashboardId: id };
      },
    };
    window.__kizenCustomBlocks = hook;
    return () => {
      if (window.__kizenCustomBlocks === hook) {
        delete window.__kizenCustomBlocks;
      }
    };
  }, [queryClient]);
};

export default useCustomBlockRefreshHook;
